<template>
    <ContentComponent />
</template>

<script>
    import ContentComponent from '@/components/CompetitionsPage/ContentComponent'

    export default {
        name: "Competitions",
        components: {
            ContentComponent
        }
    }
</script>

<style lang="sass" scoped>
</style>

